<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  @if (type === 'Add') {
    <div i18n="@@addNewReference">Add New Reference</div>
  }
  @if (type !== 'Add') {
    <div i18n="@@editReference">Edit Reference</div>
  }
  <mat-icon (click)="closeDialog()" class="cursor" i18n-label="@@closeDialog" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="addReferenceForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@instituteNameLabel">Institute name</mat-label>
        <input data-testid="name_input"  matInput id="name" i18n-placeholder="@@institutePlaceholder" placeholder="Institute name" name="name" formControlName="name" required />
        <mat-error>
          @if (!addReferenceForm.get('name').valid && addReferenceForm.get('name').touched) {
            @if (addReferenceForm.get('name').errors && addReferenceForm.get('name').errors['required'] || addReferenceForm.get('name').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@instituteDepartmentLabel">Institute department</mat-label>
        <input data-testid="department_input"  matInput id="department" i18n-placeholder="@@instituteDepartmentPlaceholder" placeholder="Institute department" name="department" formControlName="department" required>
        <mat-error>  
          @if (!addReferenceForm.get('department').valid && addReferenceForm.get('department').touched) {
            @if (addReferenceForm.get('department').errors && addReferenceForm.get('department').errors['required'] || addReferenceForm.get('name').hasError('whitespace')
              ) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@contactNameLabel">Contact name</mat-label>
        <input data-testid="contact_name_input"  matInput id="contactName"  i18n-placeholder="@@contactNamePlaceholder" placeholder="Contact name" name="contactName" formControlName="contactName" required>
        <mat-error>  
          @if (!addReferenceForm.get('contactName').valid && addReferenceForm.get('contactName').touched) {
            @if (addReferenceForm.get('contactName').errors && addReferenceForm.get('contactName').errors['required'] || addReferenceForm.get('contactName').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@contactEmailLabel">Contact email</mat-label>
        <input data-testid="email_input" matInput id="email" placeholder="Contact Email" i18n-placeholder="@@contactEmailPlaceholder" name="email" formControlName="email" required />
        <mat-error>
          @if (!addReferenceForm.get('email').valid && addReferenceForm.get('email').touched) {
            @if (addReferenceForm.get('email').errors && addReferenceForm.get('email').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
          @if (addReferenceForm.get('email').errors && !addReferenceForm.get('email').errors['required'] && addReferenceForm.get('email').errors['emailNotValid']) {
            <span i18n="@@inValidEmail">Please enter a valid email</span>
          }
        </mat-error>
      </mat-form-field>
      <div class="form-group d-flex">
        <mat-form-field style="width: 32%" appearance="outline">
          <mat-label i18n="@@countryCodeLabel">Country code</mat-label>
          <input (keypress)="numberOnly($event)" data-testid="country_code" matInput id="country_code" placeholder="001" i18n-placeholder="@@countryCodePlaceholder" name="country_code" formControlName="country_code" required />
          <mat-error>
            @if (!addReferenceForm.get('country_code').valid && addReferenceForm.get('country_code').touched) {
              @if (addReferenceForm.get('country_code').errors && addReferenceForm.get('country_code').errors['required']) {
                <span i18n="@@inValidRequiredField">Required</span>
              }
            }
            @if (addReferenceForm.get('country_code').errors && addReferenceForm.get('country_code').errors['maxlength'] && !addReferenceForm.get('country_code').errors['required']) {
              <span  i18n="@@invalid_country_code_format">Max. 5 digits</span>
            }
          </mat-error>
        </mat-form-field>
        <mat-form-field class="flex-grow ml-8" appearance="outline">
          <mat-label i18n="@@contactPhoneLabel">Contact phone</mat-label>
          <input (keypress)="numberOnly($event)" data-testid="phone_input" matInput id="phone" i18n-placeholder="@@contactPhonePlaceholder" placeholder="Contact phone" name="phone" formControlName="phone" required />
          <mat-error>
            @if (!addReferenceForm.get('phone').valid && addReferenceForm.get('phone').touched) {
              @if (addReferenceForm.get('phone').errors && addReferenceForm.get('phone').errors['required']) {
                <span i18n="@@inValidRequiredField">This field is required</span>
              }
            }
            @if (addReferenceForm.get('phone').errors && addReferenceForm.get('phone').errors['minlength'] && !addReferenceForm.get('phone').errors['required']) {
              <span i18n="@@invalid_phone_min_length">Please enter 7 digits minimum</span>
            }
            @if (addReferenceForm.get('phone').errors && addReferenceForm.get('phone').errors['maxlength'] && !addReferenceForm.get('phone').errors['required']) {
              <span  i18n="@@invalid_phone_max_length">Please enter 14 digits maximum</span>
            }
          </mat-error>
        </mat-form-field>
      </div>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@qouteLabel">Qoute</mat-label>
        <input data-testid="qoute_input"  matInput id="qoute" placeholder="Qoute" i18n-placeholder="@@qoutePlaceholder" name="qoute" formControlName="qoute">
      </mat-form-field>
      <mat-form-field class="w-100" appearance="outline">
        <mat-chip-grid #chipList>
          @for (department of departments; track department; let index = $index) {
            <mat-chip-row
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(department, index)">
              {{department.name}}
              @if (removable) {
                <mat-icon matChipRemove i18n-label="@@removeDepartment" aria-label="Remove department">cancel</mat-icon>
              }
            </mat-chip-row>
          }
          <input
            data-testid="departments_input"
            (keyup)="searchDepartment($event)"
            placeholder="Departments *"
            i18n-placeholder="@@departmentsPlaceholder"
            #departmentInput
            required
            [formControl]="departmentCtrl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)">
        </mat-chip-grid>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          @for (department of filteredDepartments | async; track department) {
            <mat-option [value]="department">
              {{department.name}}
            </mat-option>
          }
        </mat-autocomplete>
        @if (isLoading) {
          <mat-icon class="cursor" matSuffix i18n-label="@@loadingSpinner" aria-label="Loading">
            <mat-spinner class="spinner" diameter="20"></mat-spinner>
          </mat-icon>
        }
      </mat-form-field>
      @if (invalidDepartments) {
        <div i18n="@@invalidDepartmentsMessage" class="error">Please enter departments to proceed</div>
      }
      <mat-card>
        <mat-card-content class="d-flex justify-content-between align-items-center">
          <div i18n="@@allowConnected" class="mat-subtitle-1" matTooltip ellipsisTooltip>Allowed to be connected</div>
          <mat-checkbox formControlName="allowContacted" (change)="allowContactedToggle($event.source.checked)" color="accent" i18n-label="@@allowConnectedCheckbox" aria-label="Allowed to be connected"></mat-checkbox>
        </mat-card-content>
      </mat-card>
    </div>
    <div mat-dialog-actions>
      @if (type === 'Add') {
        <button i18n="@@add" data-testid="add_reference_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Add</button>
      }
      @if (type !== 'Add') {
        <button i18n="@@save" data-testid="edit_reference_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Save</button>
      }
    </div>
  </form>
</mat-dialog-content>